import { inject, injectable } from 'inversify';

import { backendUrl } from 'src/config';
import {
  CreateSessionParams,
  idVerificationServiceInterface,
  VerificationSessionResponse,
} from 'src/features/verification/data/service/idVerificationService.types';
import { AxiosResponse } from 'axios';
import HttpClient from 'src/features/http';

@injectable()
class IdVerificationService implements idVerificationServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public async getOrCreateSession(
    params: CreateSessionParams
  ): Promise<AxiosResponse<VerificationSessionResponse>> {
    return this.client.getClient().post<VerificationSessionResponse>(
      `/users/verification/create/`,
      {},
      {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${params.accessToken}` },
      }
    );
  }

  public async getSessionStatus(
    params: CreateSessionParams
  ): Promise<AxiosResponse<VerificationSessionResponse>> {
    return this.client.getClient().post<VerificationSessionResponse>(
      `/users/verification/status/`,
      {},
      {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${params.accessToken}` },
        validateStatus: () => true,
      }
    );
  }
}

export default IdVerificationService;
